import PricingListItem from '../../../../Domain/PricingListItem';
import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../../Helpers/ValidityHelper';
import PricingService from '../../../../Services/PricingService';

// Drives the GeneralEditWizzardBaseFigma bulk "Assign To" action panel. Not entity CRUD, so
// entityName is omitted and the plain 'Assign To' title wins. A single visible field keeps it in
// the compact centered modal.
class EditAssignToWindowDescription {
  static titleForCreate = 'Assign To';
  static titleForEdit = 'Assign To';
  static finishButtonLabel = 'Save';
  static itemType = PricingListItem;
  static serviceFunction = (edited) => PricingService.MultiplePost(edited);
  static messageOnSuccess = 'Pricing has been updated!';

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'AssignedTo',
          label: 'Assigned To',
          className: 'col-12',
          type: InputTypesEnum.UserSelect,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
      ],
    },
  ];
}

export default EditAssignToWindowDescription;
